import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { MdDarkMode, MdLightMode, MdMenu, MdClose } from "react-icons/md";
import '../styles/Navbar.css';

const Navbar = ({ toggleTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
        <NavLink to="/" exact onClick={toggleMenu}>Home</NavLink>
        <NavLink to="/about" onClick={toggleMenu}>About</NavLink>
        <NavLink to="/skills" onClick={toggleMenu}>Skills</NavLink>
        <NavLink to="/projects" onClick={toggleMenu}>Projects</NavLink>
        <NavLink to="/certificates" onClick={toggleMenu}>Certificates</NavLink>
        <NavLink to="/experience" onClick={toggleMenu}>Experience</NavLink>
        <NavLink to="/education" onClick={toggleMenu}>Education</NavLink>
        <NavLink to="/contact" onClick={toggleMenu}>Contact</NavLink>
      </div>
      <div className="navbar-controls">
        <button onClick={toggleTheme} className="theme-btn">
          <MdDarkMode /><MdLightMode />
        </button>
        <button onClick={toggleMenu} className="menu-btn">
          {isMenuOpen ? <MdClose /> : <MdMenu />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;